var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us"},[_c('b-container',{attrs:{"fluid":"xl"}},[_c('h2',[_vm._v(_vm._s(_vm.detailObj.title))]),_c('div',{staticClass:"content w-e-text-container"},[_c('div',{attrs:{"data-slate-editor":""},domProps:{"innerHTML":_vm._s(_vm.detailObj.detail)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }